export default function formatError(e: any) {
  if (e.response && e.response.data) {
    return e.response.data.message;
  } else {
    return 'Internal Server Error';
  }
}
